import type { CSSProperties, FC, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    className?: string;
    style?: CSSProperties;
}

/** The whole card is the link, so its call to action is a span rather than a nested button. */
export const CardAction: FC<Props> = ({ children, className = '', style }) => (
    <span
        className={`absolute bottom-16 left-16 right-16 h-[40px] rounded-full flex items-center justify-center text-center text-m font-bold ${className}`}
        style={style}
    >
        {children}
    </span>
);
